<canvas
  #barChart
  id="acquisitions"
></canvas>

<pre>
  {{pulseReportChartData | json}}
</pre>
